import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { PanelLogin } from 'src/components/PanelLogin';
import { useAuthContext } from 'src/context/AuthContextProvider';

import LiabilityData from './LiabilityData';
import LiabilityPatrimony from './LiabilityPatrimony';
import LiabilityQuotes from './LiabilityQuotes';

export default function OperationFIAGROLiability({ hash }: { hash: string }) {
  const { hashId } = useParams<{ hashId: string }>();
  const { auth } = useAuthContext();

  const operationHash = hashId || hash;

  const showPanelLogin =
    !auth?.user?.subscription?.plan?.permissions?.operacoes_fiagro_passivo ||
    !auth?.isLoggedIn;

  if (showPanelLogin) {
    return (
      <Box p={2}>
        <Box>
          <PanelLogin small={undefined} message={undefined} />
        </Box>
      </Box>
    );
  }

  return (
    <Box p={2}>
      <LiabilityData hash={operationHash} />
      <LiabilityPatrimony hash={operationHash} />
      <LiabilityQuotes hash={operationHash} />
    </Box>
  );
}
